import { HttpNoData } from "../Core";

export async function getProducts(jwt) {

    const response = await HttpNoData('/api/v0/Products', 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function getCategories(jwt) {

    const response = await HttpNoData('/api/v0/productssend/categories', 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}
// new 
export async function getNewProducts(jwt) {

    const response = await HttpNoData('/api/v1/newproducts/new', 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function getNewCategories(jwt) {
    const url = `/api/v1/products/categories/new`;

    const response = await HttpNoData(url, 'GET', jwt);
    return response.data;
}